import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import ENUMS from "../../utils/ENUMS.js";
// import 'bootstrap/dist/css/bootstrap.css';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectOption from "../layout/SelectOption";
import CustomSelect from "../layout/CustomSelect";
import { BASE_URL } from "../../config.json";
let array_push = [];
let Course_arr = [];

const AddCourses = () => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [Values, setValues] = useState([]);
  const [Course, Setcourse] = useState([]);
  const [Holes, SetHoles] = useState([]);
  const [Arr, setTheArray] = useState([]);

  let history = useHistory();

  const handleClose = () => {
    setShow(false);
    SetFormList(initialValues);
    setValues([]);
  };
  const handleShow = (e) => {
    // console.log(e, 'ANSWER');
    setShow(true);
    if (e != 0) {
      // alert(e)
      // console.log(array_push, "RESUL 4");

      setEdit(true);
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      axios
        .get(`${BASE_URL}/club/course/` + e, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log(res, "ID RES");
          // console.log(res.data.data);
          // array_push=[];
          //Course_arr.push(res.data.data);
          // SetCourseList(array_push);
          // Setcourse(res.data.data);
          //   console.log(res.data.data.course_name,"CORUSER");

          Formlist.course_name = res.data.data.course_name;
          Formlist.course_number = res.data.data.course_number;
          Formlist.total_num_holes = res.data.data.golfcourseholes.total_holes;
          Formlist.golf_course_id = e;
          let result = res.data.data;
          Setcourse(result);

          setValues(result[0]);
          console.log(Formlist.golf_course_id);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (e == 0) {
      history.push("/courses-add-courses");
      setEdit(false);
    }
  };
  const AddCompition = (e) => {
    history.push("/add-competition");
  };
  const token = localStorage.getItem(ENUMS.AUTH);
  const [CourseList, SetCourseList] = useState([""]);
  const [CourseError, SetCourseError] = useState();
  const [CourseNumberError, SetCourseNumberError] = useState();

  const [holesError, SetHolesError] = useState();
  const [CommonErr, SetCommonError] = useState();

  const initialValues = {
    course_name: "",
    total_num_holes: "",
    course_number: "",
  };

  const [Formlist, SetFormList] = useState(initialValues);
const selectedClubId = localStorage.getItem("selected_club_id");

const TestFunction = () => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let url = `${BASE_URL}/club/course/`;

  // If super admin and selectedClubId exists, fetch that club's courses
  if (selectedClubId) {
    url = `${BASE_URL}/club/golfclub/${selectedClubId}/courses/`;
  }

  axios
    .get(url, config)
    .then((res) => {
      console.log(res.data.data, "RESPONSE");

      array_push = [];
      array_push.push(res.data.data);
      SetCourseList(array_push);
      console.log(array_push);
      
      localStorage.setItem("courses", JSON.stringify(res.data.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

  const HolesDropdown = () => {
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    axios
      .get(`${BASE_URL}/club/get_course_holes/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res, "DROPDWON");
        SetHoles(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = () => {
    console.log(Formlist, "Test");
    if (
      Formlist.course_name === "" ||
      Formlist.course_name === undefined ||
      Formlist.total_num_holes === "" ||
      Formlist.total_num_holes === undefined ||
      Formlist.course_number === "" ||
      Formlist.course_number === undefined
    ) {
      SetCourseError("* Course is required");
      SetHolesError("* Holes is required");
      SetCourseNumberError("* course Number us required");
    } else {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      console.log(Formlist, "FORM");

      if (edit === true) {
        //save api
        axios
          .put(`${BASE_URL}/club/course/`, Formlist, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log(res, "RESPONSE");
            if (res.status == 200) {
              toast.success("Course Updated SuccessFully");

              TestFunction();
              setShow(false);
              SetFormList(initialValues);
              setValues([]);
            } else {
              toast.error("Unable  to Update");
            }
          })
          .catch((err) => {
            // alert('Something Wents Wrong Please Give Proper details')
            console.log(err);
          });
      }
      if (edit === false) {
        //save api
        axios
          .post(`${BASE_URL}/club/course/`, Formlist, config)
          .then((res) => {
            console.log(res, "RESPONSE");
            if (res.status == 200) {
              toast.success("Course Save SuccessFully");

              TestFunction();
              setShow(false);
              SetFormList(initialValues);
              setValues([]);
            } else {
              toast.error("Unable to Save");
            }
          })
          .catch((err) => {
            // alert('Something Wents Wrong Please Give Proper details')
            console.log(err);
          });
      }
    }
  };

  const updateInputValue = (evt) => {
    console.log(evt, "TAT");

    const { name, value } = evt.target;
    console.log(name);
    console.log(value);
    SetFormList({
      ...Formlist,
      [name]: value,
    });
  };

  const handleChange = (e) => {
    console.log(e, "TAT");

    const { value } = e;
    console.log(value, "value");
    SetFormList({
      ...Formlist,
      total_num_holes: value,
    });
  };

  useEffect(() => {
    TestFunction();
    HolesDropdown();
  }, []);
  const userTemplate = { course_name: "", map_course: "", number_of_holes: "" };
  const [users, setUsers] = useState([userTemplate]);
  const [delUser, setDelUser] = useState();
  const addUser = () => {
    setUsers([...users, userTemplate]);
  };
  const onChange = (e, index) => {
    const updatedUsers = users.map((user, i) =>
      index == i
        ? Object.assign(user, { [e.target.name]: e.target.value })
        : user
    );
    setUsers(updatedUsers);
  };

  //Delete APi
  const removeUser = (id) => {
    axios
      .delete(`${BASE_URL}/club/course/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          golf_course_id: id,
        },
      })
      .then((res) => {
        console.log(res, "course RESPONSE");
        if (res.status == 200) {
          setShowModal(false);
          toast.success("Course Deleted SuccessFully");

          TestFunction();
        } else {
          toast.error("Unable to  Delete");
        }
      })
      .catch((err) => {
        // alert('Something Wents Wrong Please Give Proper details')
        console.log(err);
      });
  };
  Holes.forEach((e) => {
    console.log(e, "data");
  });

  return (
    <>
      <ToastContainer />

      <div className="acccore__box">
        <div className="acccore__box__sec1">
          <h2 className="acccore__box__sec1-txt text-jost-sb-24">
            Your clubs golf courses
          </h2>
          {/*<a href="#" target="_self" className="res-btn-lightgrn"><span>+</span>ADD COURSE</a>*/}
          {/*<button className="res-btn-lightgrn" onClick={() => AddCompition(0)}>Add competition</button>*/}
          <button className="res-btn-lightgrn" onClick={() => handleShow(0)}>
            ADD COURSE
          </button>
        </div>

        {showModal ? (
          <div className="modalafafaf">
            <div
              style={{
                minHeight: "20rem !important",
                width: "40rem",
                justifyContent: "space-evenly",
              }}
              className="modal__container"
            >
              <button
                className="btn-close"
                onClick={() => setShowModal(!showModal)}
              >
                &times;
              </button>
              <h2 className=" text-jost-sb-20">
                {" "}
                Are you sure you want to close this course?{" "}
              </h2>
              <div></div>
              <div style={{ display: "flex",justifyContent:"center", gap: "8px" }}>
                <button
                  className="res-btn-primary"
                  onClick={() => setShowModal(!showModal)}
                >
                  Cancel
                </button>

                <button
                  className="res-btn-lightgrn"
                  onClick={() => removeUser(delUser)}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        ) : null}

        {array_push.map((data) => {
          return data.map((user, index) => {
            // console.log(user, "user");
            return (
              <Fragment>
                <div className="acccore__box__sec2">
                  <input
                    className="acc__input-lg"
                    type="text"
                    placeholder="Course Name"
                    name="course_name"
                    onChange={(e) => onChange(e, 1)}
                    value={user.course_name}
                    required
                    readOnly
                  />

                  <NavLink
                    to={{ pathname: "/courses-map-courses", index: index }}
                    className="acccore__box__sec2-link order3"
                  >
                    MAP THIS COURSE
                  </NavLink>
                  <div className="custom-select-wrapper">
                    <div className="custom-select">
                      <div className="custom-select__trigger">
                        <span>{user.golfcourseholes.total_holes}</span>
                      </div>
                      <div className="custom-options">
                        <span className="custom-option selected" data-value="">
                          9 HOLES
                        </span>
                        <span className="custom-option " data-value="">
                          18 HOLES
                        </span>
                      </div>
                    </div>
                  </div>
                  <NavLink
                    to={{ pathname: "/courses-map-courses/hole", index: index }}
                    className="acccore__box__sec2-link order4"
                  >
                    HOLE TIMES
                  </NavLink>
                  {/* <a href="#" className="acccore__box__sec2-link">Yards & Par</a> */}
                  <NavLink
                    to={{
                      pathname: "/courses-map-courses/hole-detail",
                      index: index,
                    }}
                    className="acccore__box__sec2-link order5"
                  >
                    Yards & Par
                  </NavLink>
                   <NavLink
  to={{
    pathname: "/courses-live-view",
    index: index,
  }}
  className="acccore__box__sec2-link order5"
  onClick={() => {
    localStorage.setItem("selectedLiveCourseId", user.id);
    console.log(user.id,"selectedcourseid");
    
  }}
>
  Live View
</NavLink>


                  <Fragment>
                    {data.length > 1 && (
                      <button
                        onClick={() => {
                          setShowModal(true);
                          setDelUser(user.id);
                        }}
                        className="order6"
                      >
                        <img
                          src={
                            require("../../assets/images/del/delete.svg")
                              .default
                          }
                          alt=""
                        />
                      </button>
                    )}

                    <button
                      className="order7"
                      onClick={(e) => handleShow(user.id)}
                    >
                      <img
                        src={
                          require("../../assets/images/del/edit.svg").default
                        }
                        alt=""
                      />
                    </button>
                  </Fragment>
                </div>
              </Fragment>
            );
          });
        })}
        <Modal autoFocus={false} show={show} onHide={handleClose} size="lg">
          <div className="modalafafaf">
            <div className="acccore__modal__container">
              <Modal.Title
                style={{ padding: "0rem 0",fontSize: "18px"  }}
                className="text-jost-sb-19"
              >
                {edit ? "EDIT COURSE" : "ADD COURSE"}
              </Modal.Title>
              <Modal.Header
                className="btn-close"
                closeButton
                closeLabel=""
                size="xl"
              />
              <Modal.Body>
<div className="acccore__box" style={{gridGap: "1.5rem"}}>
                  <div className="custom-select-wrapper">
                    <div className="custom-select">
                      <input
                        className="acc__input-lg"
                        type="text"
                        placeholder="Course name"
                        name="course_name"
                        onChange={updateInputValue}
                        value={Formlist.course_name}
                        required
                      />
                      {Formlist.course_name === "" ||
                      Formlist.course_name === undefined ? (
                        <span style={{ color: "red" }}>{CourseError}</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div>
                    <CustomSelect
                      className="acc__input-lg"
                      name="number_of_holes"
                      options={Holes.map((hole) => {
                        return {
                          id: hole.id,
                          label: hole.total_holes,
                          value: hole.total_holes,
                        };
                      })}
                      placeholder="Select No Of Holes*"
                      loading={false}
                      searchable={false}
                      onChange={handleChange}
                      value={Formlist.total_num_holes}
                    />
                  </div>

                  {/* <div className="custom-select-wrapper">
                                        <div className="custom-select">


                                            <select style={{cursor: "pointer"}} name="total_num_holes" className="acc__input-lg select-bg"
                                                    onChange={updateInputValue} value={Formlist.total_num_holes}>
                                                <option value="" disabled>SELECT NO OF HOLES</option>
                                                {dropdown_list.map(data => {
                                                    return (
                                                        data.map(user => {
                                                            return (
                                                                <>

                                                                    <option value={user.holes}>{user.total_holes}</option>
                                                                </>
                                                            )
                                                        })
                                                    )
                                                })
                                                }



                                            </select>


                                            {Formlist.total_num_holes === '' || Formlist.total_num_holes === undefined ? (
                                                <span style={{color: 'red'}}>{holesError}</span>) : ''}

                                            <div className="custom-options">
                                                <span className="custom-option selected" data-value="">9 HOLES</span>
                                                <span className="custom-option " data-value="">18 HOLES</span>

                                            </div>
                                        </div>
                                    </div> */}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div
                  style={{
                    display: "flex",
                    padding: "1rem 0 0 1rem",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    style={{ marginRight: "2rem" }}
 className="res-btn-primary"                      variant="secondary"
                    size="lg"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                  <Button
 className="res-btn-lightgrn"                      variant="primary"
                    size="lg"
                    onClick={handleSubmit}
                  >
                    {edit ? "Update" : "Save"}
                  </Button>
                </div>
              </Modal.Footer>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AddCourses;
